import(/* webpackMode: "eager" */ "C:\\BKABuildBet04\\_work\\4285\\s\\FlexSelectRebuild.API\\ClientApp\\src\\app\\page.tsx")